// src/services/BackupService.js

import axios from 'axios';
import config from '../config';

const BackupService = {
  // Fetch all backups
  getAll: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/backups`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Fetch a specific backup by ID
  get: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/backups/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Create a new backup
  create: async (data) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${config.apiBaseUrl}/backups`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Update a backup by ID
  update: async (id, data) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${config.apiBaseUrl}/backups/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Delete a backup by ID
  delete: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${config.apiBaseUrl}/backups/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },
};

export default BackupService;
